<template>
  <div class=" text-center inactive-instance">
    <v-row dense class="text-center ma-6 ">
      <v-col cols="12" sm="6" offset-sm="3" class="py-2 mt-0">
        <img src="@/assets/cluvi_logo.png" class="mx-auto mt-12 mb-4" height="53" />
      </v-col>
      <v-col cols="12" sm="6" offset-sm="3" class="py-1 mt-0">
        <span class="inactive-text" v-html="$t('inactive-instance.inactive')" />
      </v-col>
      <v-col cols="12" sm="6" offset-sm="3" class="py-0 my-8 px-10">
        <img src="@/assets/inactive_instance.png" class="mx-auto" width="60%" />
      </v-col>
      <v-col cols="12" sm="6" offset-sm="3" class="py-0 mt-0 px-1">
        <v-sheet cla class="pa-3" elevation="4">
          <small class="msge" v-html="$t('INVALIDATE', { name: instance.name })"></small>
        </v-sheet>
      </v-col>
      <v-col cols="12" sm="6" offset-sm="3" class="mt-4">
        <v-btn
          class="my-4 btn-text-lowercase btn-primary-cluvi rounded-lg"
          dark block x-large href="https://servicios.cluvi.co/menu" target="_blank"
          v-html="$t('inactive-instance.cluvi_restautants')"
        />
        <v-btn
          class="my-4 mt-8 btn-text-lowercase btn-secondary-cluvi rounded-lg"
          block x-large target="_blank" href="https://www.cluvi.co/restaurantes"
          v-html="$t('inactive-instance.others_restaurants')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState,mapMutations } from 'vuex';

export default {
  name: 'InactiveInstanceView',
  computed: {
    ...mapState('customer', ['instance'])
  },
  created() {
    this.SetLoading(false);
  },
  methods: {
    ...mapMutations('template', ['SetLoading']),
  }
}
</script>

<style scoped lang="scss">
  .v-sheet {
    background-color: white;
    color: black;
    border-radius: 8px;
  }
  .msge {
    font-family: 'Poppins', sans-serif!important;
    font-size: 0.875rem;
    line-height: 1.3rem;
  }
  .inactive-text {
    font-family: 'Poppins', sans-serif!important;
    font-size: 2.2rem!important;
    line-height: 2.2rem!important;
    text-align: center!important;
    font-weight: 999!important;
    color: black;
  }

  .btn-primary-cluvi {
    background-color: #7B11F5!important;
  }

  .btn-secondary-cluvi {
    background-color: #00000000!important;
    color: #687280!important;
    border: 1px solid #DCE1E6!important;
    box-shadow: none;
  }
  .btn-text-lowercase {
    font-size: 1rem !important;
    font-weight: 500;
    line-height: 1.25rem;
    letter-spacing: 0.0333333333em !important;
    text-transform: none;
  }
  .inactive-instance {
    height: 100%;
    background: white;
    margin-top: -50px;
    z-index: 5;
    & .linktree {
      z-index: 5000;
    }
  }
</style>
